import { atom } from 'recoil';

import type { SidebarPanelType } from '@/components/RightSidebar/DM/types';

export const chatSettingsOpenState = atom<boolean>({
    key: 'chatSettingsOpen',
    default: false
});

export const rightSidebarPanelState = atom<SidebarPanelType>({
    key: 'rightSidebarPanel',
    default: null
});
